import { SVGProps } from 'react';
import { cn } from '@/utils/styles';

interface HamburgerIconProps extends SVGProps<SVGSVGElement> {
  isMenuOpen?: boolean;
}

export default function HamburgerIcon({
  isMenuOpen,
  ...props
}: HamburgerIconProps) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" {...props}>
      <rect
        className={cn({
          'origin-[0_0] transition-transform duration-100 ease-in-out': true,
          '-translate-y-[1px] rotate-45': isMenuOpen,
        })}
        style={{
          transformBox: 'stroke-box',
        }}
        id="Rectangle 11"
        x="4"
        y="6"
        width="16"
        height="2"
      />
      <rect
        className={cn({
          'transition-opacity duration-100 ease-in-out': true,
          'opacity-0': isMenuOpen,
        })}
        id="Rectangle 13"
        x="4"
        y="11"
        width="16"
        height="2"
      />
      <rect
        className={cn({
          'origin-[0_0] transition-transform duration-100 ease-in-out': true,
          '-translate-x-[1px] -rotate-45': isMenuOpen,
        })}
        id="Rectangle 14"
        style={{
          transformBox: 'stroke-box',
        }}
        x="4"
        y="16"
        width="16"
        height="2"
      />
    </svg>
  );
}
